import { ApiProperty } from "@nestjs/swagger"

export class DeviceReq{
    @ApiProperty()
    imei: number;

    @ApiProperty()
    deviceUid: string;

    @ApiProperty()
    interval:any;

    @ApiProperty()
    network:any;

    @ApiProperty()
    timestamp:number;

    @ApiProperty()
    battery:number;

    @ApiProperty()
    battery_voltage:number;

    @ApiProperty()
    location:number[];

    @ApiProperty()
    temperature:number[];

    @ApiProperty()
    humidity:any[];

    @ApiProperty()
    event_type?:string[]
    

    constructor(    
        imei: number,
        deviceUid: string,
        interval:any,
        network:any,
        timestamp:number,
        battery:number,
        battery_voltage:number,
        location:any[],
        temperature:number[],
        humidity:number[],
        event_type?:string[]
      ){
        this.imei = imei;
        this.deviceUid = deviceUid;
        this.interval = interval;
        this.network = network;
        this.timestamp = timestamp;
        this.battery = battery;
        this.battery_voltage = battery_voltage;
        this.location = location;
        this.temperature = temperature;
        this.humidity = humidity;
        this.event_type = event_type;
    }
}